import EventClass from "common/utils/ui/event-class";
import { on as onEvent } from "common/utils/ui/event";
import DesignFileUploadingClass from "./design-file-uploading-class";

export default class DesignUploadCtaPlpDropzoneClass extends EventClass {
  #props;

  #eventSelector;

  constructor(props) {
    super(props);

    this.#props = props;
    this.#eventSelector = props.eventSelector;
  }

  get #$dropZone() {
    return document.querySelector(this.#eventSelector);
  }

  static preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  event(event, $target) {
    super.event(event, $target);

    this.#handleDragLeave(event);

    const { files } = event.dataTransfer;

    if (files && files.length > 0) {
      const file = new DesignFileUploadingClass({
        file: files[0],
        triggerSource: "plp",
        ...this.#props
      });
      file.processFile();
    }
  }

  #handleDragEnter(event) {
    DesignUploadCtaPlpDropzoneClass.preventDefaults(event);
    this.#$dropZone.classList.add("border-blue-600", "bg-blue-50");
  }

  #handleDragLeave(event) {
    DesignUploadCtaPlpDropzoneClass.preventDefaults(event);
    this.#$dropZone.classList.remove("border-blue-600", "bg-blue-50");
  }

  init() {
    // Highlight on drag
    onEvent("dragenter", this.#eventSelector, this.#handleDragEnter.bind(this));
    onEvent("dragover", this.#eventSelector, this.#handleDragEnter.bind(this));
    onEvent("dragleave", this.#eventSelector, this.#handleDragLeave.bind(this));
  }
}
